import { TILES_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ITileOnboardResponse, ITilesOnboardBody } from "@/api_framework/api_modals/Tiles";
import { setTilesAdd } from "@/app_redux/reducers/slices/auth/tiles_slice";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useAddTileAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterParams: ITilesOnboardBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(TILES_MODULE?.TILES_ONBOARD_API?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ITileOnboardResponse>) => {
            if (res.data.status === true) {
              dispatch(setTilesAdd({ data: res.data.data }));
              toast.success(res.data.message || "Tile has been created");
              return { status: true, message: res.data.data };
            } else {
              dispatch(setTilesAdd(null));
              toast.error(res.data.message || "Failed to create tile");
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(setTilesAdd(null));
            toast.error("Server Error: " + e.message);
            return { status: false, message: null };
          });
        return response;
      } catch (e: any) {
        dispatch(setTilesAdd(null));
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
